import NumberInput, { type NumberInputConfigProps, type NumberInputProps } from "@common/controls/Inputs/Number/component";

export { type NumberInputConfigProps, type NumberInputProps };
export default NumberInput;

import "./style.less";
